import { ReactNode } from "react";
import { useViewport } from "src/contexts";
import { Css } from "~generated/css";
import { MobileAuthHeader } from "./MobileAuthHeader";

type AuthFormContainerProps = {
  title: string;
  onBack: () => void;
  children: ReactNode;
};

export function AuthFormContainer({ title, onBack, children }: AuthFormContainerProps) {
  const { isMobile } = useViewport();
  return (
    <div css={isMobile ? Css.relative.w100.h100.oh.df.fdc.$ : Css.df.fdc.jcc.aic.vh100.gap3.wPx(500).mxa.$}>
      {isMobile && <MobileAuthHeader title={title} onBack={onBack} />}
      {children}
    </div>
  );
}
